import { createStore } from 'redux';
import reducer from './reducer';

let STORE = null;

export default function( initialState ) {
	if ( null === STORE ) {
		STORE = createStore( reducer, initialState );
	}
	return STORE;
}
